import React from 'react';
import s from './MessageWithIcon.scss';

const MessageWithIcon = props => {
  const { text = 'More to come...' } = props;
  return (
    <div className={s.messageWrapper}>
      {text} <i className={s.smileyIcon} />
    </div>
  );
};

export default MessageWithIcon;
